<app-modal
  title="Create Data Element"
  subtitle="Define field properties and data types"
  (closed)="closed.emit()"
>
  @if (loading()) {
    <div class="flex items-center justify-center py-10 text-xs text-slate-400">Loading...</div>
  } @else {
    <!-- Element Name -->
    <div class="flex flex-col gap-1.5 mb-5">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Element Name</label>
      <input
        type="text"
        placeholder="Type name..."
        [value]="name()"
        (input)="name.set($any($event.target).value)"
        [class.border-red-400]="showErrors() && !name().trim()"
        [class.ring-2]="showErrors() && !name().trim()"
        [class.ring-red-100]="showErrors() && !name().trim()"
        class="w-full"
      />
      @if (showErrors() && !name().trim()) {
        <span class="text-2xs text-red-500">Required</span>
      }
    </div>

    <!-- Definition -->
    <div class="flex flex-col gap-1.5 mb-5">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Definition</label>
      <textarea
        placeholder="Type definition..."
        rows="3"
        [value]="definition()"
        (input)="definition.set($any($event.target).value)"
        [class.border-red-400]="showErrors() && !definition().trim()"
        [class.ring-2]="showErrors() && !definition().trim()"
        [class.ring-red-100]="showErrors() && !definition().trim()"
        class="w-full"
      ></textarea>
      @if (showErrors() && !definition().trim()) {
        <span class="text-2xs text-red-500">Required</span>
      }
    </div>

    <!-- Data Type -->
    <div class="flex flex-col gap-1.5 mb-5">
      <label class="text-xs font-semibold text-navy-600 tracking-wider">Data Type</label>
      <app-select
        placeholder="Select data type"
        [options]="dataTypeOptions()"
        [value]="dataTypeId()"
        (changed)="dataTypeId.set($event)"
        [error]="showErrors() && !dataTypeId()"
      />
      @if (showErrors() && !dataTypeId()) {
        <span class="text-2xs text-red-500">Required</span>
      }
    </div>
  }

  <div modal-footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="closed.emit()"
      class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      [disabled]="submitting() || loading()"
      class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {{ submitting() ? 'Creating...' : 'Create Element' }}
    </button>
  </div>
</app-modal>
